import { useState } from "react";

const faqs = [
  {
    q: "How fast can I renew my passport?",
    a: "With Fast Passport Center, you can renew your passport in as little as 3 business days from when we receive your documents. Add 1–2 days for your documents to reach us if mailing, plus overnight FedEx return delivery. Most customers in our 3-day tier have their renewed passport in hand within 5–7 days of starting their order.",
  },
  {
    q: "Can I renew my passport without going to a passport office?",
    a: "Yes — if you qualify for renewal using Form DS-82, the entire process is done by mail. You never need to visit a passport agency, an acceptance facility, or make any appointments. You mail us your documents and we handle the rest. This is the biggest advantage of qualifying for renewal over a new passport application.",
  },
  {
    q: "My passport expired — can I still renew it fast?",
    a: "Yes, as long as your passport was issued within the last 15 years and meets the other DS-82 eligibility requirements. An expired passport does not disqualify you from renewal by mail. We renew expired passports every day — it's one of our most common requests.",
  },
  {
    q: "How do I know if I qualify for fast renewal or need a new passport?",
    a: "You qualify for fast renewal (DS-82) if: your passport was issued when you were 16 or older, issued within the last 15 years, is undamaged, and is in your current legal name (or you can document a name change). If any of these don't apply, you'll need a new passport application (DS-11) instead. Call 877-253-0084 if you're not sure — we'll tell you in 2 minutes.",
  },
  {
    q: "What documents do I need for fast passport renewal?",
    a: "For renewal by mail (DS-82): your current passport, Form DS-82 (completed and signed), one 2x2 inch passport photo taken within the last 6 months, proof of travel (flight itinerary or travel confirmation), and any name change documentation if applicable (marriage certificate, divorce decree, or court order). Fast Passport Center provides a personalized checklist when you start your order.",
  },
  {
    q: "How is Fast Passport Center faster than going through the post office?",
    a: "The post office puts your application in a standard mail queue — government expedited processing through the mail takes 2–3 weeks, plus mailing time on both ends. Fast Passport Center is a registered State Dept. courier with reserved daily submission slots at passport agencies. We hand-deliver your application the next business day, bypassing the mail queue entirely. That's why we can process renewals in 3–9 business days instead of weeks.",
  },
  {
    q: "Why is Fast Passport Center cheaper than FedEx or Staples?",
    a: "FedEx Office and Staples are resellers — they charge a service fee and then send your application to a registered courier like us. You pay their markup plus the actual courier cost. When you use Fast Passport Center directly, you pay only our direct courier fee — no middleman, no retail markup. We are typically 20–80% less expensive than retail passport service counters.",
  },
  {
    q: "Can I renew my passport fast if I recently got married and changed my name?",
    a: "Yes — if your passport was issued within the last 15 years and meets the other DS-82 requirements, you can renew by mail even with a name change. You'll need to include your certified marriage certificate with your renewal application. Note: if your passport was issued less than 1 year ago and your only change is the name, you may qualify for Form DS-5504 instead — a free name-change correction form. Call us and we'll tell you which applies to your situation.",
  },
  {
    q: "What if I need to renew my passport but my trip is in less than 3 days?",
    a: "Call us immediately at 877-253-0084. A sub-3-day window is extremely tight. Whether it's possible depends on what day it is, what type of renewal you need, and how quickly your documents can reach us. We'll give you an honest assessment immediately and tell you exactly what's possible.",
  },
  {
    q: "Will I get my old passport back after fast renewal?",
    a: "Yes. Your old, cancelled passport is returned to you separately after your renewal is processed — it typically arrives within a few weeks of your new passport. Keep it in a safe place as it may contain valid visas you'll want to use for future travel.",
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (i: number) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-[#1B4D3E] text-center mb-10">
          Fast Passport Renewal — Frequently Asked Questions
        </h2>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div key={i} className="border border-gray-200 rounded-lg overflow-hidden">
              <button
                onClick={() => toggle(i)}
                className="w-full flex items-center justify-between px-5 py-4 text-left bg-white hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <span className="text-sm md:text-base font-semibold text-gray-800 pr-4">{faq.q}</span>
                <span className={`flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center transition-colors ${
                  openIndex === i ? "bg-[#1B4D3E]" : "bg-green-100"
                }`}>
                  <i className={`${openIndex === i ? "ri-subtract-line text-white" : "ri-add-line text-[#1B4D3E]"} text-sm`}></i>
                </span>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5 text-gray-600 text-sm md:text-base leading-relaxed">
                  {faq.a}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}